// extracted by mini-css-extract-plugin
export default {"tasks":"wP-z","task":"xP-z","svg":"yP-z","text":"zP-z"};